// extracted by mini-css-extract-plugin
export var filterIncDec = "_cp-0";
export var leftBorder = "_cp-1";
export var rightBorder = "_cp-2";
export var stringInput = "_cp-3";